import React from 'react';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <div className="bg-[#1A3257] rounded-2xl shadow-xl p-6 md:p-12 border-2 border-[#2ECC71]/30" data-id="element-133">
          <div className="flex flex-col items-center text-center" data-id="element-134">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-[#2ECC71]/10 rounded-full flex items-center justify-center mb-4 md:mb-6" data-id="element-135">
              <Shield className="w-8 h-8 md:w-10 md:h-10 text-[#2ECC71]" data-id="element-136" />
            </div>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-4 md:mb-6" data-id="element-137">
              🛡️ Gwarancja zwrotu pieniędzy 100% w ciągu 7 dni
            </h2>

            <div className="space-y-3 md:space-y-4 text-base md:text-lg text-[#E8EAF0] max-w-2xl" data-id="element-138">
              <p data-id="element-139">Pobierz wszystko. Przeczytaj wszystko.</p>
              <p data-id="element-140">Zastosuj na swoich zajęciach.</p>
              <p className="font-bold text-white text-lg md:text-xl mt-2" data-id="element-141">
                Jeśli nie jesteś w 100% zadowolony w ciągu 7 dni
                <br data-id="element-142" />
                zwracamy Ci pełną kwotę.
              </p>
              <p className="text-sm md:text-base text-[#9BA3B5] mt-4 md:mt-6" data-id="element-143">
                Bez pytań. Bez skomplikowanych procedur.
                <br data-id="element-144" />
                Całe ryzyko bierzemy na siebie.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}